module.exports = __webpack_public_path__ + "static/img/The Lovers.5b9762d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Lovers.jpg
// module id = 1318
// module chunks = 0